<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 2.main-container-start -->
    <div class="main">
      <div class="top">
        <img src="../../images/logo.png" class="img" />
      </div>
      <div class="bottom flexStyle1">
        <div class="left">
          <img src="../../images/bg2.png" class="img" />
        </div>
        <div class="middle">
          <div class="top">{{ title }}</div>
          <el-form ref="loginForm" :model="loginForm" class="login-form">
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                type="text"
                auto-complete="off"
                placeholder="账号"
              >
                <svg-icon
                  slot="prefix"
                  icon-class="user"
                  class="el-input__icon input-icon"
                />
              </el-input>
            </el-form-item>
            <el-form-item prop="pwd">
              <el-input
                v-model="loginForm.pwd"
                type="text"
                auto-complete="off"
                placeholder="..."
                @keyup.enter.native="loginBefore"
              >
                <svg-icon
                  slot="prefix"
                  icon-class="password"
                  class="el-input__icon input-icon"
                />
              </el-input>
            </el-form-item>
            <el-form-item style="width:100%;">
              <el-button
                :loading="loading"
                size="medium"
                type="primary"
                style="width:100%;background-color: red;"
                @click.native.prevent="loginBefore"
              >
                <span v-if="!loading">登 录</span>
                <span v-else>登 录 中...</span>
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="right">
          <img src="../../images/bg3.png" class="img" />
        </div>
      </div>
    </div>
    <!-- 2.main-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import { loginRequest, baseInfoRequest } from "../../public/js/service";

export default {
  name: "Login2",
  data() {
    // 1.data
    return {
      loading: false,
      username: "", // 1.1.客户名称
      password: "", // 1.2.密码
      title: "", // 1.3.title
      loginForm: {
        username: null, // 1.1.客户名称
        pwd: null, // 1.2.密码
      },
    };
  },

  methods: {
    // 2.methods
    register() {
      // 2.1.注册
      this.$router.push("/register");
    },

    loginBefore() {
      // 2.2.登录之前
      if (this.verifacation()) {
        this.login();
      }
    },

    verifacation() {
      // 2.3.校验表单方法
      let result = false;
      if (!this.loginForm.username.trim()) {
        // 客户名称校验
        this.$notify({
          title: "提示",
          message: "请输入客户名称",
        });
      } else {
        if (!this.loginForm.password.trim()) {
          // 密码校验
          this.$notify({
            title: "提示",
            message: "请输入密码",
          });
        } else {
          result = true;
        }
      }

      return result;
    },

    login() {
      // 2.4.登录请求
      this.openLoading();
      let data = {
        username: this.loginForm.username,
        password: this.loginForm.pwd,
        sysId: Number(this.sysId),
      };

      loginRequest(data).then((res) => {
        this.closeLoading();
        if (res) {
          let r = res.token || "";
          if (r) {
            localStorage.token = r;
            localStorage.loginStatus = 1;
          }
          this.$router.push("/goodsCenter");
        }
      });
    },

    pageEnterKeyWatch() {
      // 2.5.页面回车监听
      let _this = this;
      let psw = this.$refs["paswd"];
      psw.addEventListener("keydown", (event) => {
        // 2.5.1.页面监听回车事件
        var key = event.keyCode;
        if (key == 13) {
          _this.loginBefore();
        }
      });
    },

    getBaseInfo() {
      // 2.6.获取站点基础信息
      let url = window.location.hostname;
      if (
        url == "192.168.31.6" ||
        url == "app95.ksdemo.cn" ||
        url == "localhost"
      ) {
        url = "bbbb.df.vue.waiwubang.com";
      }

      baseInfoRequest(url).then((res) => {
        if (res) {
          let r = res.data[0];
          this.title = r.web_name || "";
          this.sysId = r.sys_id || "";
          localStorage.baseInfo = JSON.stringify(r);
          window.document.title = r.web_title;
        }
      });
    },

    openLoading() {
      // 2.7.打开加载遮罩层
      this.loadingInstance = this.$loading.service({
        fullscreen: true,
        lock: true,
      });
    },

    closeLoading() {
      // 2.8.关闭遮罩层
      this.loadingInstance.close();
    },
  },
  created() {
    this.getBaseInfo();
  },
  mounted() {
    // 3.mounted
    //this.pageEnterKeyWatch();
  },
};
</script>

<style scoped lang="scss">
@import "./login.scss";
</style>
